import React from "react";
import Helmet from "react-helmet";
import Navbar from "../components/navbar.js";
import Footer from "../components/footer.js";
import "tachyons";
import "../styles/custom.tachyons.css";

export default (props) => (
  <React.Fragment>
    <Helmet>
      <body className="bg-near-white mid-gray" />
    </Helmet>
    <div className="h-100 sans-serif bg-white">
      <div className="w-100 center tc flex flex-wrap justify-between-ns justify-center mw9 center-l pt2 pb2">
        <div className="flex flex-column">
          <img alt="TRƯỜNG ĐẠI HỌC QUY NHƠN" title="TRƯỜNG ĐẠI HỌC QUY NHƠN"  src="/logo_qnu.png" />
        </div>
        <div className="flex flex-column">
          <h2 style={{ color: "#383f5c" }}>
            CƠ SỞ DỮ LIỆU KHOA HỌC VÀ CÔNG NGHỆ
          </h2>
        </div>
      </div>
    </div>
    <Navbar
      activeHome={props.activeHome}
      activeNhaKhoaHoc={props.activeNhaKhoaHoc}
      activeBaiBao={props.activeBaiBao}
      activeDeTai={props.activeDeTai}
      activeGiaoTrinh={props.activeGiaoTrinh}
      activeSach={props.activeSach}
      activeBieuMau={props.activeBieuMau}
      activeCTHTQuocTe={props.activeCTHTQuocTe}
    />
    {props.children}
    <Footer />
  </React.Fragment>
);
